export default __webpack_public_path__ + "static/media/banner.c077dd35.svg";